import { Helmet } from 'react-helmet-async';

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RetailInvest by Heinrichs Immobilien",
    "alternateName": "Heinrichs Immobilien",
    "url": "https://investmentlead.preview.emergentagent.com",
    "logo": "https://investmentlead.preview.emergentagent.com/logo.png",
    "description": "Spezialisierter Makler für Handelsimmobilien in Deutschland. Wir begleiten Eigentümer beim erfolgreichen Verkauf von Lebensmittelmärkten, Discountern, Fachmärkten und Fachmarktzentren.",
    "founder": {
      "@type": "Person",
      "name": "Andreas Heinrichs",
      "jobTitle": "Geschäftsführer"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rindermarkt 8",
      "addressLocality": "Freising",
      "postalCode": "85354",
      "addressCountry": "DE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+49-8161-1851360",
      "contactType": "customer service",
      "email": "info@heinrichsimmobilien.de",
      "availableLanguage": "German"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Deutschland"
    },
    "knowsAbout": [
      "Handelsimmobilien",
      "Lebensmittelmärkte",
      "Discounter",
      "Fachmärkte",
      "Fachmarktzentren",
      "Einzelhandelsimmobilien",
      "WAULT-Berechnung",
      "Immobilienbewertung"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};